import React, { useMemo } from 'react'
import { NEXT_GEN_APP_URL } from 'utils/AllURLs'

export const ReachNativeIFrame = ({
  path,
  width = '100%',
  height = '100%',
}) => {
  const iframeSrc = useMemo(() => `${NEXT_GEN_APP_URL}/${path}`, [path])

  return (
    <iframe
      width={width}
      height={height}
      frameBorder={0}
      sandbox="allow-same-origin allow-scripts"
      title="reach-native-next-gen"
      src={iframeSrc}
    />
  )
}

export default ReachNativeIFrame
